import React from 'react';

import { Status } from '@gogame/components';

import {
  STATUS_DRAFT,
  STATUS_FINAL_PLAN,
  STATUS_ADJUSTMENT_DRAFT,
  STATUS_FINAL_ADJUSTED_PLAN,
} from './constants';

export const getColor = (id) => {
  switch (id) {
    case STATUS_DRAFT:
      return 'draft';
    case STATUS_FINAL_PLAN:
      return 'success';
    case STATUS_ADJUSTMENT_DRAFT:
      return 'info';
    case STATUS_FINAL_ADJUSTED_PLAN:
      return 'success';
  }
};
export default ({ id, children }) => {
  return <Status color={getColor(id)}>{children}</Status>;
};
